<template>
  <component :is="dashboardComponent" />
</template>

<script>
import { mapGetters } from "vuex";

const SignalsureDashboard = () => import("./SignalsureDashboard.vue");
const AgentDashboard = () => import("./AgentDashboard.vue");

export default {
  name: "DashboardWrapper",
  components: {
    SignalsureDashboard,
    AgentDashboard,
  },
  computed: {
    ...mapGetters({
      getLoggedInUser: "appData/getLoggedInUser",
    }),
    dashboardComponent() {
      const user = this.getLoggedInUser;
      if (user && user.role_data && user.role_data.code_name === "su") {
        return "SignalsureDashboard";
      } else if (user && user.role_data && user.role_data.code_name === "ag") {
        return "AgentDashboard";
      }
      return "SignalsureDashboard";
    },
  },
};
</script>
